import {
  Control,
  Controller,
  FieldErrors,
  UseFormGetValues,
  useWatch,
} from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CostCenter } from '~/data/costCenters';
import { useSxStyles } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/components/ScheduleEmployment/components/FormComponent/components/Common/useStyles';
import { Form } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/useScheduleChanges';
import { LegacyAutocompleteField } from '~/legacy-components/LegacyForms';

type Props = {
  control: Control<Form>;
  getValues: UseFormGetValues<Form>;
  getCostCenterValues: (positionUnit?: number) => CostCenter[];
  errors: FieldErrors<Form>;
  index: number;
  deleteSelectedCC: (id: number) => void;
};

export const CostCenterComponent = ({
  control,
  getValues,
  getCostCenterValues,
  errors,
  index,
  deleteSelectedCC,
}: Props) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();
  const requiredText = t('fieldIsRequired');
  // @ts-ignore
  useWatch({
    control,
    name: `schedule.${index}.empPosition.fInternalPositionUnit`,
  });
  // @ts-ignore
  const fInternalPositionUnitValue = getValues(
    `schedule.${index}.empPosition.fInternalPositionUnit`,
  );
  const costCenterValues = getCostCenterValues(fInternalPositionUnitValue);
  return (
    <Controller
      control={control}
      name={`schedule.${index}.empPosition.fEmpCostCenter`}
      rules={{ validate: (value) => (value && value !== -1) || requiredText }}
      render={({ field: { onChange, value } }) => (
        <LegacyAutocompleteField
          required
          sx={sxStyles.selectStyle}
          placeholder={
            fInternalPositionUnitValue === -1 ? t('laSelectFirstOrgUnit') : ' '
          }
          options={costCenterValues}
          getOptionLabel={(c) => `${c.fCostCenterCode}, ${c.fCostCenterName}`}
          onChange={(e, value) => {
            onChange(value?.fCostCenterId || -1);
            const additionalCC = getValues(
              `schedule.${index}.empPosition.${
                value?.fCostCenterId || -1
              }-cc-percent`,
            );
            if (additionalCC || additionalCC === '') {
              deleteSelectedCC(value?.fCostCenterId || -1);
            }
          }}
          value={
            costCenterValues.find((cc) => cc.fCostCenterId === value) || null
          }
          fieldError={errors.schedule?.[index]?.empPosition?.fEmpCostCenter}
          label={t('fEmpCostCenter')}
        />
      )}
    />
  );
};
